import { CaseAdmin, PatientFullInsurance } from "pwapi";

import { CaseAdminDetail } from "shared/reducers/admin/adminCaseReducer";
import { shallowLeftDiff } from "shared/utils/formUtils";

export const submissionFieldsForPatient = (
  adminCase: CaseAdminDetail,
  values?: PatientFullInsurance
) => {
  const { patient } = adminCase;
  if (!values) values = patient;
  return {
    id: values.id,
    first_name: values.first_name,
    last_name: values.last_name,
    sex: values.sex,
    date_of_birth: values.date_of_birth,
    ...(adminCase.source === CaseAdmin.source.PW && {
      middle_initial: values.middle_initial,
      ssn: values.ssn,
      employer: values.employer,
      medical_record_number: values.medical_record_number,
    }),
  };
};

export const shallowPatientComparison = (
  adminCase: CaseAdminDetail,
  values: PatientFullInsurance
) => {
  const oldValues = submissionFieldsForPatient(adminCase);
  const newValues = submissionFieldsForPatient(adminCase, values);

  return shallowLeftDiff<ReturnType<typeof submissionFieldsForPatient>>(
    oldValues,
    newValues
  );
};
